import BaseLayout from "@/Layouts/BaseLayout";
import {formatDMY} from "@/shared/lib/date";
import {Breadcrumbs} from "@/shared/ui/Breadcrumbs";
import {Link} from "@/shared/ui/Link";
import {Picture} from "@/shared/ui/Picture";
import {Button} from "@/shared/ui/Button";
import styles from "./SalesPage.module.scss";

const Index = (props) => {
    const {h1 = '', sales = [], hideBreadcrumbs = false} = props;

    return (
        <BaseLayout {...props}>
            <div className={styles.section}>
                <div className={`globalContainer`}>
                    <div className={styles.pageContainer}>
                        <Breadcrumbs
                            items={[
                                {label: "Главная", href: "/"},
                                {label: h1},
                            ]}
                            // hideBreadcrumbs={hideBreadcrumbs}
                        />
                        <h1 className={styles.h1}>{h1}</h1>
                        {sales.length === 0 && (
                            <h2>Все акции завершены! Следите за нашими новостями!</h2>
                        )}
                        {sales.length > 0 && (
                            <div className={styles.cardsContainer}>
                                {sales.map((sale) => (
                                    <Link key={sale.id} href={`/stocks/${sale.alias}`} className={styles.card}>
                                        <Picture
                                            src={sale.img}
                                            srcMobile={sale.img_mobile}
                                            alt={sale.name}
                                            classes={{image: styles.image}}
                                        />
                                        <div className={styles.content}>
                                            <div>
                                                <p className={styles.title}>{sale.name}</p>
                                                <p className={styles.date}>
                                                    c {formatDMY(sale.published_start)}
                                                    {sale.published_end != null && (
                                                        <> по {formatDMY(sale.published_end)}</>
                                                    )}
                                                </p>
                                            </div>
                                            <Button variant={`secondary`} fullWidth>Подробнее</Button>
                                        </div>
                                    </Link>
                                ))}
                            </div>
                        )}
                    </div>
                </div>
            </div>
        </BaseLayout>
    );
};

export default Index;
